"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PorfolioMonitoringInviteStatus = void 0;
var PorfolioMonitoringInviteStatus;
(function (PorfolioMonitoringInviteStatus) {
    PorfolioMonitoringInviteStatus["Created"] = "created";
    PorfolioMonitoringInviteStatus["Pending"] = "pending";
    PorfolioMonitoringInviteStatus["Sent"] = "sent";
    PorfolioMonitoringInviteStatus["Viewed"] = "viewed";
    PorfolioMonitoringInviteStatus["Accepted"] = "accepted";
})(PorfolioMonitoringInviteStatus = exports.PorfolioMonitoringInviteStatus || (exports.PorfolioMonitoringInviteStatus = {}));
//# sourceMappingURL=PortfolioMonitoring.js.map